import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=4529514c&scoped=true&"
import script from "./QuestionList.vue?vue&type=script&lang=ts&"
export * from "./QuestionList.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionList.vue?vue&type=style&index=0&id=4529514c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4529514c",
  null
  
)

export default component.exports